export const INPUT_TYPE = 'INPUT_TYPE';
export const SUCCESS_TYPE = 'SUCCESS_TYPE';
export const FAILED_TYPE = 'FAILED_TYPE';
export const NOTIFY_ME_VARIANTS = {
    backInStock: 'BACK_ON_STOCK',
    disabled: 'NOTIFY_IS_DISABLED',
    productReleaseAnnouncement: 'PRODUCT_RELEASE_ANNOUNCEMENT',
};
export const EMAIL_SEPARATOR = '{email}';
export const SET_DATA_INITIAL_STATE = {
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
};
